import React from "react";
import HomeHero from "../home components/HomeHero";
import WhyKanthi from "../home components/WhyKanthi";
import ProductCategories from "../home components/ProductCategories";
import BlogSection from "../home components/BlogSection";
import HomeFinalCta from "../home components/HomeFinalCta";
import ReusableBanner from "../library/ReusableBanner";
import HomeVideoShowcase from "../library/HomeVideoShowcase";
import HomeExperience from "../home components/HomeExperience";

function Home() {
  return (
    <main className="home-page-shell">
      {/* <HomeHero /> */}

      <div className="pt-[72px] md:pt-[96px]">
        <ReusableBanner />
      </div>

      <WhyKanthi />
      <ProductCategories />
      <HomeVideoShowcase/>
      <HomeExperience/>
      <BlogSection />
      <HomeFinalCta />
    </main>
  );
}

export default Home;